import { Pipe, PipeTransform } from '@angular/core';
import { Application } from '@enums/application.enums';
import { POST_TYPE_KEY } from '@constants/constant';

@Pipe({
  name: 'contentLengthHandler'
})
export class ContentLengthHandlerPipe implements PipeTransform {
  transform(val: any, length: any = 200, maxLines: number = 3, minRemainingChars: number = 5): string {
    let description = '';
    if (val && val.type === POST_TYPE_KEY.ARTICLE) {
      description = val.cta_title;
    } else {
      description = val?.description ?? val?.question ?? '';
    }

    if (description) {
      if (val && val.type === POST_TYPE_KEY.ARTICLE) {
        const tags = Array.from(new Set([...val.user_tag]));
        tags.forEach((ele) => {
          const hashTag = `#${ele?.trim()}`;
          let insertIdx = -1;
          if (description.includes(Application.SEE_MORE_DIV)) {
            insertIdx = description.indexOf(Application.SEE_MORE_DIV);
          } else if (description.includes(Application.SEE_LESS_DIV)) {
            insertIdx = description.indexOf(Application.SEE_LESS_DIV);
          }
          if (insertIdx !== -1) {
            description = description.slice(0, insertIdx) + ` <a class='clickToHashTag@#${hashTag}'>${hashTag}</a> ` + description.slice(insertIdx);
          } else {
            description = description + ` <a class='clickToHashTag@#${hashTag}'>${hashTag}</a>`;
          }
        });
      }

      const lines = description.split('\n');
      const exceedsLength = length !== -1 && description.length > Number(length);
      const exceedsLines = lines.length > maxLines;

      if (exceedsLength || exceedsLines) {
        let truncatedDescription = description;

        if (exceedsLines) {
          const truncatedLines = lines.slice(0, maxLines);
          truncatedDescription = truncatedLines.join('\n');
        }

        if (exceedsLength && truncatedDescription.length > Number(length)) {
          truncatedDescription = truncatedDescription.substring(
            Number(Application.ZERO),
            Number(length)
          );
        }

        const remainingChars = description.length - truncatedDescription.length;
        if (remainingChars < minRemainingChars) {
          return description;
        }

        if (!val.isMore) {
          return `${truncatedDescription}...${Application.SEE_MORE_DIV}`;
        } else {
          return `${description} ${Application.SEE_LESS_DIV}`;
        }
      } else {
        return description;
      }
    } else {
      return description;
    }
  }
}
